"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryPartVersionData = void 0;
exports.arbitraryTerminal = arbitraryTerminal;
exports.arbitraryTerminalsMap = arbitraryTerminalsMap;
exports.arbitraryPartData = arbitraryPartData;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const document_1 = require("../../src/document");
const part_1 = require("../../src/part");
const user_1 = require("./user");
function arbitraryTerminal(constraints = {}) {
    return fast_check_1.default.record({
        // TODO: This doesn't actually conform to the type... this is testing "reasonable behavior"
        name: fast_check_1.default.hexaString({ minLength: 2 }),
        uid: fast_check_1.default.uuid(),
        pin_number: constraints.pin_number
            ? fast_check_1.default.constant(`${constraints.pin_number}`)
            : fast_check_1.default.constant(`${fast_check_1.default.integer({ min: 0, max: 100 })}`),
    });
}
function arbitraryTerminalsMap(constraints = {}) {
    const lengthConstraint = constraints.terminalCount
        ? { minLength: constraints.terminalCount, maxLength: constraints.terminalCount }
        : { minLength: 1, maxLength: 40 };
    const terminals = fast_check_1.default.uniqueArray(arbitraryTerminal(), {
        ...lengthConstraint,
        comparator: (a, b) => a.uid !== b.uid && a.pin_number !== b.pin_number,
    });
    return terminals.map((ts) => {
        const map = {};
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        ts.forEach((t) => (map[t.uid] = t));
        return map;
    });
}
function arbitraryPartData(constrains) {
    return fast_check_1.default
        .record({
        uid: fast_check_1.default.uuid(),
        name: fast_check_1.default.string(),
        description: fast_check_1.default.string(),
        owner_uid: fast_check_1.default.uuid(),
        version: fast_check_1.default.string(),
        created_at: fast_check_1.default.integer(),
        userAccessList: fast_check_1.default.array(fast_check_1.default.uuid()),
        anyoneCanView: fast_check_1.default.boolean(),
        star_count: fast_check_1.default.integer({ min: 0 }),
        test_data: fast_check_1.default.boolean(),
        contentScore: fast_check_1.default.integer(),
    })
        .map((i) => ({
        ...i,
        owner_uid: constrains?.user?.uid ?? i.owner_uid,
        test_data: constrains?.isTest === true,
        is_published: true,
    }));
}
/**
 * A pretty weak implementation, but an implementation nonetheless!
 */
exports.arbitraryPartVersionData = fast_check_1.default
    .record({
    user: (0, user_1.arbitraryNonAnonymousUser)(),
    description: fast_check_1.default.lorem(),
    behavior: fast_check_1.default.lorem(),
    partUid: fast_check_1.default.uuid(),
    partVersionKey: fast_check_1.default.uuid(),
    terminals: arbitraryTerminalsMap(),
})
    .map((data) => {
    const doc = (0, document_1.createNewDocumentData)(data.user, undefined, undefined, data.description, data.behavior);
    const pv = (0, part_1.createPartVersionFromDocument)(doc, data.partUid, data.partVersionKey);
    pv.terminals = data.terminals;
    return pv;
});
//# sourceMappingURL=part.js.map